import { DateValidationFunction } from './DateField'
import Label from './Label/Label'
import React from 'react'
import SelectMonthYear from './Select/SelectMonthYear.component'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
import theme from '../../global/theme'

interface YearMonthFieldProps {
  disabled?: boolean
  label?: string
  value?: any
  onChange?: (date: any) => void
  error?: boolean
  errorText?: string
  bottomPadding?: boolean
  isRequired?: boolean
  customValidation?: DateValidationFunction
}

const YearMonthField: React.FC<YearMonthFieldProps> = ({
  disabled = false,
  label,
  value,
  onChange,
  error,
  errorText,
  bottomPadding = true,
  isRequired = false,
  customValidation,
}) => {
  const [validationError, setValidationError] = React.useState<string>('')
  const [showValidationError, setShowValidationError] =
    React.useState<boolean>(false)

  const setValidationErrorTrue = () => setShowValidationError(true)
  const setValidationErrorFalse = () => setShowValidationError(false)

  const handleChange = (dateString: string) => {
    let processedDate = null
    if (dateString) {
      processedDate = dayjs(dateString)

      if (customValidation) {
        const validationResult = customValidation(processedDate)
        if (!validationResult.isValid) {
          setValidationError(validationResult.errorMessage || 'Invalid date')
          setShowValidationError(true)
        } else {
          setValidationError('')
          setShowValidationError(false)
        }
      } else {
        setValidationError('')
        setShowValidationError(false)
      }
    } else {
      setValidationError('')
      setShowValidationError(false)
    }

    if (onChange) {
      onChange(processedDate)
    }
  }

  const hasError = error || !!validationError || showValidationError
  const displayErrorText = validationError || errorText

  const formattedValue = value ? dayjs(value).format('YYYY-MM-DD') : ''

  return (
    <div style={{ paddingBottom: bottomPadding ? '20px' : 0 }}>
      {label && (
        <Label>
          {label}
          {isRequired && (
            <span style={{ color: theme.colors.secondary }}> *</span>
          )}
        </Label>
      )}
      <SelectMonthYear
        value={formattedValue}
        handleChange={handleChange}
        showValidationError={hasError}
        setValidationErrorTrue={setValidationErrorTrue}
        setValidationErrorFalse={setValidationErrorFalse}
        disabled={disabled}
        bottomPadding={false}
      />
      {hasError && displayErrorText && (
        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {displayErrorText}
        </div>
      )}
    </div>
  )
}

export default observer(YearMonthField)
